import { gql } from '@apollo/client';
import { CategoryFields, CoreLocationFields } from '../fragments/staticData';

export const getStaticFooterData = gql`
  query StaticFooterData {
    ...CoreLocationFields
  }
  ${CoreLocationFields}
`;

export const getStaticDataQuery = gql`
  query StaticData {
    regions(cityId: 1) {
      id
      name
      slug
      latitude
      longitude
    }
    cities(filter: { scope: UNPOPULAR }, limit: 80) {
      id
      name
      slug
    }
    categories {
      ...CategoryFields
      children {
        ...CategoryFields
      }
    }
  }
  ${CategoryFields}
`;
